import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

export function StatsCardsSkeleton() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {[...Array(4)].map((_, i) => (
        <Card key={i} className="bg-card border-border">
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div className="space-y-2">
                <Skeleton className="h-4 w-20 bg-muted" />
                <Skeleton className="h-7 w-12 bg-muted" />
              </div>
              <Skeleton className="h-8 w-8 rounded bg-muted" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}

export function SearchFiltersSkeleton() {
  return (
    <div className="space-y-4">
      <Skeleton className="h-10 w-full bg-muted" />
      <div className="flex gap-3">
        <Skeleton className="h-9 w-28 bg-muted" />
        <Skeleton className="h-9 w-28 bg-muted" />
        <Skeleton className="h-9 w-24 bg-muted" />
      </div>
    </div>
  )
}

export function TableRowSkeleton() {
  return (
    <tr className="border-border">
      <td className="p-4">
        <Skeleton className="h-4 w-4 bg-muted" />
      </td>
      <td className="p-4">
        <Skeleton className="h-4 w-24 bg-muted" />
      </td>
      <td className="p-4">
        <div className="space-y-1">
          <Skeleton className="h-4 w-28 bg-muted" />
          <Skeleton className="h-3 w-20 bg-muted" />
        </div>
      </td>
      <td className="p-4">
        <Skeleton className="h-6 w-16 rounded-full bg-muted" />
      </td>
      <td className="p-4">
        <Skeleton className="h-5 w-12 bg-muted" />
      </td>
      <td className="p-4">
        <Skeleton className="h-4 w-16 bg-muted" />
      </td>
      <td className="p-4">
        <Skeleton className="h-4 w-28 bg-muted" />
      </td>
      <td className="p-4">
        <Skeleton className="h-8 w-8 bg-muted" />
      </td>
    </tr>
  )
}

export function DevicesTableSkeleton() {
  return (
    <Card className="bg-card border-border">
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-border">
                <th className="p-4 w-12">
                  <Skeleton className="h-4 w-4 bg-muted" />
                </th>
                <th className="p-4 text-left">
                  <Skeleton className="h-4 w-16 bg-muted" />
                </th>
                <th className="p-4 text-left">
                  <Skeleton className="h-4 w-24 bg-muted" />
                </th>
                <th className="p-4 text-left">
                  <Skeleton className="h-4 w-12 bg-muted" />
                </th>
                <th className="p-4 text-left">
                  <Skeleton className="h-4 w-24 bg-muted" />
                </th>
                <th className="p-4 text-left">
                  <Skeleton className="h-4 w-14 bg-muted" />
                </th>
                <th className="p-4 text-left">
                  <Skeleton className="h-4 w-24 bg-muted" />
                </th>
                <th className="p-4 w-16">
                  <Skeleton className="h-4 w-14 bg-muted" />
                </th>
              </tr>
            </thead>
            <tbody>
              {[...Array(8)].map((_, i) => (
                <TableRowSkeleton key={i} />
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex items-center justify-between px-4 py-4 border-t border-border">
          <Skeleton className="h-4 w-40 bg-muted" />
          <div className="flex gap-2">
            <Skeleton className="h-8 w-20 bg-muted" />
            <Skeleton className="h-8 w-8 bg-muted" />
            <Skeleton className="h-8 w-8 bg-muted" />
            <Skeleton className="h-8 w-8 bg-muted" />
            <Skeleton className="h-8 w-20 bg-muted" />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export function FullPageSkeleton() {
  return (
    <div className="space-y-6">
      <StatsCardsSkeleton />
      <SearchFiltersSkeleton />
      <DevicesTableSkeleton />
    </div>
  )
}
